module.exports = __webpack_public_path__ + "img/GNSS.b0d0556e.png";